export const environment = {
  production: false,
  // api_url: 'http://localhost:3000',
  api_url: 'https://ows-api.myplgs.com',

  GOOGLE_MAP_API_KEY: 'AIzaSyBSMRpSXcSI7isxttqv4Togbc-TTwmzvYk'
};
